import { atom, useAtom } from 'jotai';
import { ConversationBaseDto } from './api.types';

const conversationAtom = atom<ConversationBaseDto | undefined>(undefined);
const resentAtom = atom<Record<string, string>>({});

export const useConversation = () => {
  const [conversation, updateConversation] = useAtom(conversationAtom);
  const [recent, setRecent] = useAtom(resentAtom);
  const setConversation = (conversation?: ConversationBaseDto) => {
    if (conversation?.id && conversation.equipmentId) {
      setRecent({ ...recent, [conversation.equipmentId]: conversation.id });
    }
    updateConversation(conversation);
  };

  return { conversation, setConversation, recent };
};
